<script setup lang="ts">
import {inject, onMounted, ref} from "vue";
import {
  EAutorizacaoAcaoTipo,
  type InfoAutorizacaoDesconto,
  type ResultadoCodigoAutorizacao
} from "@/domain/type/autorizacao.type";
import {EModalId, type ModalAutorizacaoCodigo} from "@/domain/type/modal.type";
import {useModalStore} from "@/stores/modal.store";
import {useAuthStore} from "@/stores/auth.store";
import AutorizacaoAcaoService from "@/domain/services/autorizacaoAcao.service";

const modalStore = useModalStore();
const dialogRef: any = inject("dialogRef");

const codigoAutorizacao = ref("");

const isLoadingVerificandoCodigo = ref(false);

const isErrorCodigo = ref(false);
const errorMensagem = ref("");
const isStateComponentError = ref(false);

const tipoAutorizacao = ref<EAutorizacaoAcaoTipo>();
const empresaId = ref("");
const infoAutorizacaoDesconto = ref<InfoAutorizacaoDesconto | undefined>();
const cgpe = useAuthStore().getUserCgpe();

const onVerificarCodigo = () => {

  if (codigoAutorizacao.value.trim().length != 6) return;

  isErrorCodigo.value = false;
  isLoadingVerificandoCodigo.value = true;

  AutorizacaoAcaoService.verificarCodigo({
    cgpe: cgpe,
    empresaId: empresaId.value,
    tipoAutorizacao: tipoAutorizacao.value ?? 0,
    codigoAutorizacao: codigoAutorizacao.value,
    porcentagemDesconto: infoAutorizacaoDesconto.value?.porcentagemDesconto ?? 0,
    grupoPlanoSeguroId: infoAutorizacaoDesconto.value?.grupoPlanoSeguroId ?? 0

  })
      .then(ret => {
        if (ret.data.resultado) {
          fecharModal(ret.data);
        } else {

          isErrorCodigo.value = true;
          if (ret.data.mensagem.trim() == "") {
            errorMensagem.value = "Verifique o código informado";
          } else {
            errorMensagem.value = ret.data.mensagem;
          }


        }


      })
      .catch(() => {
        isErrorCodigo.value = true;

      })
      .finally(() => {
        isLoadingVerificandoCodigo.value = false;
      })


}

//fecha o modal e retorna o resultado
const fecharModal = (resultado: ResultadoCodigoAutorizacao) => {

  if (dialogRef && dialogRef.value) {
    dialogRef.value.close({
      resultadoAutorizacao: resultado
    });
  }

}

onMounted(() => {
  try {

    const modalParams = modalStore.getModal(EModalId.modalAutorizacaoCodigo)?.getParam() as ModalAutorizacaoCodigo;

    if (modalParams) {

      if (modalParams.propTipoAutorizacao) {
        tipoAutorizacao.value = modalParams.propTipoAutorizacao;
      }

      if (modalParams.propEmpresaId) {
        empresaId.value = modalParams.propEmpresaId;
      }

      if (modalParams.propInfoAutorizacaoDesconto) {
        infoAutorizacaoDesconto.value = modalParams.propInfoAutorizacaoDesconto;
      }


    }

    //define o status do componente com erro de acordo com a validacao das informacoes obrigatorias
    if (tipoAutorizacao.value == undefined || empresaId.value.trim() == "") {

      isStateComponentError.value = true;
    } else {

      if (tipoAutorizacao.value == EAutorizacaoAcaoTipo.DescontoNoProduto) {
        //verifica se foi informado os dados para verificação do desconto
        if (infoAutorizacaoDesconto.value == undefined) {
          isStateComponentError.value = true;
        } else {
          if (!(infoAutorizacaoDesconto.value.grupoPlanoSeguroId > 0) || !(infoAutorizacaoDesconto.value.porcentagemDesconto > 0)) {
            isStateComponentError.value = true;
          } else {
            isStateComponentError.value = false;
          }
        }
      } else {
        isStateComponentError.value = false;
      }

    }


  } catch {
    isStateComponentError.value = true;
  }


  if (!isStateComponentError.value) {

    setTimeout(() => {
      (document.querySelector(".inputCodigo") as HTMLInputElement).focus();
    }, 400)

  }

})

</script>

<template>


  <div v-if="!isStateComponentError" class="w-full">
    <div class="flex flex-col font-bold text-center">
      <label class="text-xl">Informe o Código</label>

      <div class="text-center flex flex-col mt-5 mb-5">
        <div class="flex justify-center ">
          <InputOtp v-model="codigoAutorizacao" :length="6" size="large" class="font-bold !text-4xls  "
                    :pt:pcInputText:root="{'class':' capitalize !text-4xl !h-[5rem] !w-[5rem] inputCodigo'}"
                    @keyup.enter="onVerificarCodigo" :invalid="isErrorCodigo" @input="onVerificarCodigo"
          />
        </div>

        <small v-if="isErrorCodigo" class="p-error mt-2">{{errorMensagem}}</small>

      </div>

      <div class="text-center">
        <Button size="large" icon="pi pi-check" label="VERIFICAR" class="mb-4" @click="onVerificarCodigo"
                :loading="isLoadingVerificandoCodigo"></Button>
      </div>


    </div>

  </div>

  <div v-if="isStateComponentError" class="component-state-error">
    <span class="p-error text-2xl">Component Error</span>
  </div>
</template>

<style scoped>

</style>